module.exports = __webpack_public_path__ + "img/unionpay.f920d9b3.svg";